import * as Yup from 'yup';

export const validationSchema = (T) =>
  Yup.object().shape({
    email: Yup.string().required(T.required_field).email(T.right_email_with_exp),
  });
